<template>
  <transition name="fade">
    <div class="smart-page">
      <div class="section-container" id="smart-fullpage">
         <section class="landing-screen market-screen smart-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                 <div class="headline-1"><b>增材型高精微集成电路整体解决方案</b></div>
                  <div class="description">
                    <p>绿展科技是国家级高新技术企业，专注于集成电路增材制造领域。我们自主研发电子材料、封装材料和增材制造工艺，并改良了精密制造设备。我们提供低至 1μm 线宽的集成电路与系统增材制造解决方案，实现了从材料到产品生产的全流程闭环。</p>
                  </div>
                  <div class="headline-3">低至 1μm 线宽的高精微集成电路制造解决方案</div>
                  <div class="headline-3">包括：自研材料、工艺、设备、器件设计、模组量产</div>
              </div> <div class="lightgreen-gradient-href"><a href="http://www.gpnano.com" target="_blank">了解更多详情www.gpnano.com</a></div>
           </div>
            <div class="bg-product"><img src="../assets/product/ink.png" /></div>
          </div>
        </section>
       <section class="landing-screen market-screen smart-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>绿展孵化器</b></div>
                 <div class="description">
                   绿展孵化器是深圳前海深港合作区最大孵化器。孵化器以公司主营业务即印刷电子行业为主要孵化领域，协同孵化金融、ICT、现代物流、服务制造以及其他前海重点发展行业企业。
                 </div>
                 <div class="headline-3">孵化信息</div>
                 <div class="description">
                   <ul>
                     <li>•孵化场地3000平</li>
                     <li>•入驻孵化企业20家</li>
                     <li>•港澳台外资企业数量占比54%</li>
                     <li>•产生企业专利发明26项</li>
                     <li>•5家孵化企业与绿展集团有业务合作方向</li>
                 </ul>
                 </div>
                  <div class="lightgreen-gradient-href"><a href="http://www.gpginnovation.com" target="_blank">了解更多详情www.gpginnovation.com</a></div>
               </div>
            </div>
             <div class="bg-product"><img src="../assets/product/office.png" /></div>
          </div>
        </section>
        <section class="landing-screen market-screen smart-slider section" id="landingScreen"  v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>中清国华（山东）生态科技有限公司</b></div>
                 <div class="description">
                  <p>公司于2021年在山东青岛注册成立，注册资本2000万元人民币，公司是清华大学建筑设计研究院、中国钢铁研究总院华东分院、中国海洋大学、上海大学等高等院校及研究机构为背景的授权实体企业，在装配式超低能耗建筑全体系、稀土耐候耐蚀钢深加工全体系、新型国际精准易货贸易、海洋经济一体化、智能工程机器人、装配式现代农畜牧业设施全体系，在新材料、乡村振兴、一二三产融合、新能源等领域和产业，拥有丰富的科研成果积累及实践经验和市场开发运营能力。公司将以此在国内沿海沿江以及国外一带一路沿线国家打造十个以上高科技产业园区，以出口为主，绿色产业每年产值不少于千亿元。公司同时以此开展供应链金融全体系业务。</p>
            </div>
             </div>
            </div>
                <div class="bg-product"><img src="../assets/product/shengtai.png" /></div>
            </div>
        </section>
    <section class="landing-screen market-screen smart-slider section" id="landingScreen"  v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>深圳市鸿通文化传媒</b></div>
                 <div class="description">
                  <p>深圳市鸿通文化传媒有限公司，投资了多部影视作品及数字文化产品，公司是中华文化促进会、中国非物质文化遗产保护协会、文化产业（中国）协作体的理事单位。</p>
            </div>
             </div>
            </div>
                <div class="bg-product"><img src="../assets/product/movies.png" /></div>
            </div>
        </section>
        <section class="landing-screen market-screen smart-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>清华大学老科技工作者协会专家工作站</b></div>
                 <div class="description">
                  公司与清华大学两岸研究院长期战略合作，被授予“清华大学老科技工作者协会专家工作站”，全方位开展科技创新事业。
                 </div>
                  <div class="description">
                    专家工作站以习近平新时代中国特色社会主义理论为指导，贯彻科教兴国和人才强国的战略方针，充分发挥老科学技术工作者的作用，为科技进步、振兴中华再作贡献。
                 </div>
          </div>
            </div>
             <div class="bg-product"><img src="../assets/product/laokejixiehui.png" /></div>
          </div>
        </section>
        <section class="landing-screen market-screen smart-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>天境科幻影都：文旅IP及运营平台</b></div>
                 <div class="description">
                  上海天旅品牌有限公司拥有一流的文旅IP及运营平台。团队由日本动漫大师为主组成，代表国际领先水平。全新打造以科幻电影为系列内容的《天境科幻影都》，目前该项目在长三角得到了政府和央企的认同，正在洽商落地事宜。
                </div>
                  <div class="description">
                    天境科幻影以动漫内容创意和影视职业教育领域的人才优势为核心竞争力，为培育中国动漫之星，创建中国科幻语境赋能，加快形成一批具有竞争力的骨干创意企业，创作一批具有示范和推动能力的重大项目，使科幻内容成为中国前瞻未来走向世界的典范。
                 </div>
               </div>
            </div>
             <div class="bg-product"><img src="../assets/product/tianjing.png" /></div>
          </div>
        </section>
        <section class="landing-screen market-screen smart-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>江西区域科技创新产业化、文旅康养产业</b></div>
                 <div class="description">
                  江西省昌盛投资发展有限公司正在江西省南昌市因地制宜布局开展科技创新产业化、文旅康养产业两项重点工作。公司与清华大学两岸研究院长期战略合作，成立“清华大学老科技工作者协会专家工作站”（江西省工作站）全方位开展科技创新事业。
                 </div>
                 <div class="description">
                  公司在南昌市湾里区建设科学家小镇院士村，打造科技工作者工作生活一体化运营平台，最大限度集聚人才，进而促进更多院士专家、科技人才与南昌合作、赴南昌发展。这将有助于助力湾里打造高颜值的生态旅游区、高质量的生态经济区、高标准的生态居住区，构建“宜居、宜业、宜游”的康养旅居和大健康品牌。
                 </div>
               </div>
            </div>
             <div class="bg-product"><img src="../assets/product/wenlv.png" /></div>
          </div>
        </section>
        <section class="landing-screen market-screen smart-slider section" id="landingScreen"  v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>酷睿奥⼈⼯智能</b></div>
                 <div class="description">
                  <p>提供完整的技术解决⽅案——包括⾃然语⾔处理与理解、⾃动编程、数据分析与挖掘、⾃动可视化模型等。</p>
                  <p>不同于Google、百度，它颠覆性地创造了⼀种新的技术Dialogic™，并以此技术发明了垂直信息检索引擎（Vertical Information Retrieval）。通过简单的提问和对话，与数据进⾏交互，随时随地获得⼀⼀对应、确定的答案。</p>
                  <p>这是⼀个⾰命性的⼈⼯智能技术，让信息在⼏秒钟内触⼿可及。未来，Quarrio将成为⼈们进⾏信息检索的全新入⼝和⽅式。</p>
                 </div>
             </div>
            </div>
           <div class="col">
               <div class="bg-product"><img src="../assets/product/quarrio.png" /></div>
            </div>
            </div>
        </section>
        <!-- <section class="landing-screen market-screen smart-slider section" id="landingScreen"  v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>小分子大豆蛋白肽</b></div>
                 <div class="description">
                 <b>品质保证</b>——澳门出品，值得信赖。同时也是首届中国国际进口博览会参展品牌。
                 </div>
                 <div class="description">
                 <b>国际先进技术</b>——来自“国家千人计划”专家团队，采用最新的生物酶解技术和高科技萃取技术，领先行业。
                 </div>
                 <div class="description">
                 <b>植物蛋白更健康</b>——从非转基因大豆提取提纯，富含人体所需氨基酸、膳食纤维、维生素C，可被人体直接吸收（尤其适合肠胃吸收不佳的人群食用）。
                 </div>
                  <div class="description">
                 <b>促进肠胃消化吸收</b>——改善肠道菌群环境，排出毒素。
                 </div>
                 <div class="description">
                 <b>参与合成胶原蛋白</b>——减少皮肤色素沉淀，令肌肤更加细腻有光泽。
                 </div>
                 <div class="description">
                 <b>提高身体免疫力</b>——促进人体对钙、镁、锌、铜、铁等矿物质的吸收，缓解疲劳。
                 </div>
             </div>
            </div>
                <div class="bg-product"><img src="../assets/product/tai.png" /></div>
            </div>
        </section> -->
           <GPFooter />
      </div>
   </div>
  </transition>
</template>

<style lang="scss" src="./Products.scss">
</style>

<script>
import Fullpage from 'fullpage.js'
export default {
  name: 'SmartPage',
  props: {},
  data () {
    return {
      smartSliders: null,
      isPitfallHide: true
    }
  },
  methods: {
    formatter (num) {
      return num.toFixed(1)
    },
    animStart (e, n) {
      this.$refs[`teamNum_${n}`].start()
    },
    hidePitfall () {
      this.isPitfallHide = true
    },
    showPitfall () {
      this.isPitfallHide = false
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.smartSliders === null) {
        this.initFullPage()
      }
    },
    initFullPage () {
      this.smartSliders = new Fullpage('#smart-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.smartSliders.destroy('all')
            this.smartSliders = null
          }
        }
      })
    }
  },
  created () {
  },
  destroyed () {
    if (this.smartSliders !== null) {
      this.smartSliders.destroy('all')
      this.smartSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.smartSliders === null) {
      this.initFullPage()
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Products.vue